import React from 'react';
import { Modal, Button, Form, Input, Row, Col } from 'antd';
import propTypes from 'prop-types';
import TSTable from '../common/TSTable';
import { URL_SCALE_LARGE } from '../../constance/urls';
import { useTranslation } from 'react-i18next';
import { formatComma } from '../../utils/stringFormat';
import { PlusOutlined } from '@ant-design/icons';
import { useDebounce } from 'use-debounce';

function SelectTruckTransactionModal(props) {
  const {
    open,
    onClose,
    onSelect,
    filterParams
  } = props;

  const { t } = useTranslation();
  const [form] = Form.useForm();
  const tableRef = React.useRef();
  const searchText = Form.useWatch('search', form)
  const [debouncedText] = useDebounce(searchText, 500);

  React.useEffect(() => {
    if (tableRef.current || debouncedText) {
      tableRef.current.fetch({ searchText: debouncedText, });
    }
  }, [debouncedText])

  const columns = [
    {
      title: t('truck_transactions.in_date_time'),
      dataIndex: 'in_date_time',
      render: (__, original) => new Date(original.in_date_time).toLocaleString('en-GB'),
    },
    {
      title: t('trucks.license_plate'),
      dataIndex: 'license_plate',
    },
    {
      title: t('truck_transactions.company'),
      dataIndex: 'truck_company_detail.name',
      render: (__, original) => original.truck_company_detail.name
    },
    {
      title: t('truck_transactions.in_weight'),
      dataIndex: 'in_weight',
      render: (__, original) => formatComma(original.in_weight)
    },
    {
      title: t('truck_transactions.out_weight'),
      dataIndex: 'out_weight',
      render: (__, original) => formatComma(original.out_weight)
    },
    {
      title: t('truck_transactions.net_weight'),
      dataIndex: 'net_weight',
      render: (__, original) => formatComma(original.net_weight)
    },
    {
      title: () => null,
      dataIndex: 'id',
      render: (__, original) => (
        <Button
          type='primary'
          icon={<PlusOutlined />}
          onClick={(_) => {
            onSelect(original)
            onClose()
          }}
        />

      )
    }
  ]
  const mergedParams = {
    search: debouncedText,
    ...props.params,
    ...filterParams,
  };
  return (
    <Modal
      key={open ? 'open' : 'closed'}
      open={open}
      onCancel={onClose}
      title={`${t('select')} ${t('trucks.license_plate')}`}
      footer={null}
      width={'85%'}
    >
      <Form form={form}>
        <Row>
          <Col sm={24} md={24} lg={8}>
            <Form.Item label={t('search')} name={"search"}>
              <Input
                placeholder={t('search')}
                allowClear
              />
            </Form.Item>
          </Col>
        </Row>
      </Form>

      <TSTable
        ref={tableRef}
        url={URL_SCALE_LARGE.TRUCK_TRANSACTION}
        columns={columns}
        params={mergedParams}
        scroll={{ x: 'max-content' }}
      />

    </Modal>
  )
}

SelectTruckTransactionModal.defaultProps = {
  open: false,
  onClose: () => null,
  onSelect: () => null,
  filterParams: {},
}

SelectTruckTransactionModal.propTypes = {
  open: propTypes.bool,
  onClose: propTypes.func,
  onSelect: propTypes.func,
  filterParams: propTypes.object,
}

export default React.memo(SelectTruckTransactionModal)

